import { useEffect, useRef } from "react";
import { Volume2, VolumeX } from "lucide-react";

const MUSIC_URL =
  "https://customer-assets.emergentagent.com/job_swipe-to-love/artifacts/q0yi63c4_pehla%20nasha.mp3";

export default function MusicToggle({ on, setOn }) {
  const audioRef = useRef(null);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    audio.volume = 0.55;
    if (on) {
      const p = audio.play();
      if (p && p.catch) p.catch(() => {});
    } else {
      audio.pause();
    }
  }, [on]);

  return (
    <>
      <audio
        ref={audioRef}
        src={MUSIC_URL}
        loop
        preload="auto"
        data-testid="bg-audio"
      />
      <button
        onClick={() => setOn(!on)}
        data-testid="music-toggle"
        aria-label={on ? "Mute music" : "Play music"}
        className="absolute top-4 right-4 z-50 w-10 h-10 rounded-full border border-[#D4AF37]/55 bg-[#1A110D]/55 backdrop-blur-md flex items-center justify-center text-[#D4AF37] hover:bg-[#D4AF37]/20 transition shadow-[0_4px_18px_rgba(0,0,0,0.5)]"
      >
        {on ? <Volume2 className="w-4 h-4" /> : <VolumeX className="w-4 h-4" />}
      </button>
    </>
  );
}
